export const ADMINBUYBACK_DATA_GET="ADMINBUYBACK_DATA_GET"
export const ADMINBUYBACK_DATA_SUCCESS="ADMINBUYBACK_DATA_SUCCESS"